// ReplacementChart.tsx
import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const ReplacementChart = ({ chartData, type }) => {
  console.log(chartData);
  console.log('rendering');
  //   const grouped = new Map();

  //   data.forEach((item) => {
  //     const isDouble = (item.challanNumber || '').startsWith('RC/');
  //     const key =
  //       type === 'store'
  //         ? item.warehosueCode || 'Unknown'
  //         : new Date(item.createdAt).toISOString().split('T')[0];

  //     if (!grouped.has(key)) {
  //       grouped.set(key, { single: 0, double: 0 });
  //     }

  //     const group = grouped.get(key);
  //     if (isDouble) {
  //       group.double += 1;
  //     } else {
  //       group.single += 1;
  //     }
  //   });

  //   const labels = Array.from(grouped.keys());
  //   const singleCounts = labels.map((label) => grouped.get(label)?.single);
  //   const doubleCounts = labels.map((label) => grouped.get(label)?.double);

  //   const chartData = {
  //     labels,
  //     datasets: [
  //       {
  //         label: 'Single Replacement',
  //         data: singleCounts,
  //         backgroundColor: 'rgba(75, 192, 192, 0.7)',
  //       },
  //       {
  //         label: 'Double Replacement',
  //         data: doubleCounts,
  //         backgroundColor: 'rgba(255, 99, 132, 0.7)',
  //       },
  //     ],
  //   };

  const chartOptions = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text:
          type === 'store' ? 'Replacements by Store' : 'Replacements by Day',
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Replacement Count',
        },
      },
    },
  };

  return <Bar data={chartData} options={chartOptions} />;
};

export default ReplacementChart;
